// extracted by mini-css-extract-plugin
export var dropdownContainer = "_nu-0";
export var leftAlign = "_nu-4";
export var listItem = "_nu-2";
export var listItemWrapper = "_nu-1";
export var operationText = "_nu-3";